import { Store } from './Store';
import { SongEntry } from './MusicStore';

export interface CurrentlyPlayingState {
  currentSong: SongEntry;
  queue: SongEntry[];
  currentSongIndex: number;
  playing: boolean;
}

class CurrentlyPlayingStore extends Store<CurrentlyPlayingState> {
  data(): CurrentlyPlayingState {
    return {
      currentSong: null,
      queue: [],
      currentSongIndex: -1,
      playing: false
    };
  }

  selectSong(song: SongEntry) {
    this.state.currentSong = song;
    if (!this.state.queue.includes(song)) {
      this.state.queue.push(song);
    }
    this.state.currentSongIndex = this.state.queue.indexOf(song);
  }

  setQueue(songs: SongEntry[]) {
    this.state.queue = songs;
    this.state.currentSongIndex = songs.indexOf(this.state.currentSong);
  }

  next() {
    if (this.state.queue.length > 1) {
      this.state.currentSongIndex++;
      this.state.currentSongIndex %= this.state.queue.length;
      this.selectSong(this.state.queue[this.state.currentSongIndex]);
    }
  }

  previous() {
    if (this.state.queue.length > 1) {
      this.state.currentSongIndex--;
      if (this.state.currentSongIndex < 0) this.state.currentSongIndex += this.state.queue.length;
      this.selectSong(this.state.queue[this.state.currentSongIndex]);
    }
  }
}

export default new CurrentlyPlayingStore();
